module.exports = __webpack_public_path__ + "img/step2@2x.17768c5f.jpg";